import { Injectable } from '@angular/core';
import { EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { EventInterface } from '@shared/api';
import { CustomEntityCollectionBaseService } from '../entity-collection-base.class';
import { EntityTypeEnum } from '../entity.interface';

@Injectable({
  providedIn: 'root',
})
export class EventsService extends CustomEntityCollectionBaseService<EventInterface> {
  constructor(elementsFactory: EntityCollectionServiceElementsFactory) {
    super(EntityTypeEnum.Event, elementsFactory);
  }
}
